import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ServiceModule } from '../../services/service.module';
import { ChipFilterComponent } from './chip-selector/chip-filter/chip-filter.component';
import { ChipComponent } from './chip-selector/chip/chip.component';
import { EdlProficiencyPillComponent } from './edl-proficiency-pill/edl-proficiency-pill.component';
import { EdlTooltipComponent } from './edl-tooltip/edl-tooltip.component';
import { UrlParamChipFilterComponent } from './chip-selector/url-param-chip-filter/url-param-chip-filter.component';
import { FormErrorIconComponent } from './form-error-icon/form-error-icon.component';
import { SignaturePadModule } from "angular2-signaturepad";

import { SigPadComponent } from './sig-pad/sig-pad.component';
import { PaetepSignatureComponent } from './paetep-signature/paetep-signature.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaetepSortByComponent } from './paetep-sort-by/paetep-sort-by.component';
import { UrlParamSortByComponent } from './url-param-sort-by/url-param-sort-by.component';
import { PaetepPaginationComponent } from './paetep-pagination/paetep-pagination.component';
import { EdlCommonComponentsModule, EdlCommonDirectiveModule } from '@edl-development/edl-common';
import { PaetepSearchComponent } from './paetep-search/paetep-search.component';
import { PaetepResetButtonComponent } from './paetep-reset-button/paetep-reset-button.component';
import { LaddaModule } from 'angular2-ladda';
import { PaetepLoadingContainerComponent } from './paetep-loading-container/paetep-loading-container.component';
import { UsertypePillsComponent } from './usertype-pills/usertype-pills.component';
import { UsertypePillComponent } from './usertype-pill/usertype-pill.component';
import { PaetepWorkflowCardComponent } from './paetep-workflow-card/paetep-workflow-card.component';
import { PaetepWorkflowCardStepComponent } from './paetep-workflow-card/paetep-workflow-card-step/paetep-workflow-card-step.component';
import { EdlMultiSelectComponent } from '../edl-multi-select/edl-multi-select.component';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  declarations: [
    EdlTooltipComponent,
    EdlProficiencyPillComponent,
    ChipComponent,
    ChipFilterComponent,
    UrlParamChipFilterComponent,
    FormErrorIconComponent,
    SigPadComponent,
    PaetepSignatureComponent,
    PaetepSortByComponent,
    UrlParamSortByComponent,
    PaetepPaginationComponent,
    PaetepSearchComponent,
    PaetepResetButtonComponent,
    PaetepLoadingContainerComponent,
    UsertypePillComponent,
    UsertypePillsComponent,
    PaetepWorkflowCardComponent,
    PaetepWorkflowCardStepComponent,
    EdlMultiSelectComponent
  ],
  exports: [
    EdlTooltipComponent,
    EdlProficiencyPillComponent,
    ChipFilterComponent,
    ChipComponent,
    UrlParamChipFilterComponent,
    FormErrorIconComponent,
    SigPadComponent,
    PaetepSignatureComponent,
    PaetepSortByComponent,
    UrlParamSortByComponent,
    PaetepPaginationComponent,
    PaetepSearchComponent,
    PaetepResetButtonComponent,
    PaetepLoadingContainerComponent,
    UsertypePillComponent,
    UsertypePillsComponent,
    PaetepWorkflowCardComponent,
    PaetepWorkflowCardStepComponent,
    EdlMultiSelectComponent
  ],
  imports: [
    CommonModule,
    EdlCommonComponentsModule,
    NgbModule,
    EdlCommonDirectiveModule,
    ServiceModule,
    SignaturePadModule,
    FormsModule,
    ReactiveFormsModule,
    LaddaModule,
    NgSelectModule
  ]
})
export class ComponentsModule { }
